export const LINKED_INTENT_STANDARD_LEAD_FRAMES = 4;
export const LINKED_INTENT_SMALL_LAYOUT_COLD_LEAD_FRAMES = 6;

export const linkedIntentLeadFrameLimit = snapshot => {
  const paneCount = snapshot?.paneCount;
  if (!Number.isSafeInteger(paneCount) || paneCount < 1) {
    return LINKED_INTENT_STANDARD_LEAD_FRAMES;
  }
  return paneCount <= 4
    ? LINKED_INTENT_SMALL_LAYOUT_COLD_LEAD_FRAMES
    : LINKED_INTENT_STANDARD_LEAD_FRAMES;
};
